// extracted by mini-css-extract-plugin
export default {"dashboardIcons":"social-icons_dashboardIcons__Sxr6j"};